<script setup>
import { Link, usePage } from '@inertiajs/vue3';
import axios from 'axios';
import { ArrowLeftFromLine } from '@lucide/vue';
import { ref, watch, getCurrentInstance, onMounted, onUnmounted } from 'vue';

import SidebarMenu from './SidebarMenu.vue';

const page = usePage();
const isCollapsed = ref(Boolean(page.props.sidebarCollapsed ?? false));
const sidebarMenuRef = ref();

// Access global properties for route function in SSR/CSR
const instance = getCurrentInstance();
const route = instance?.appContext.config.globalProperties.route;

const persistSidebarState = async (collapsed) => {
    try {
        await axios.post(route('sidebar.state'), { collapsed });
    } catch {
        // non-blocking: ignore errors to keep UI responsive
    }
};

const toggleSidebar = () => {
    isCollapsed.value = !isCollapsed.value;
    persistSidebarState(isCollapsed.value);
};

watch(isCollapsed, (collapsed) => {
    if (collapsed && sidebarMenuRef?.value?.collapseAllSubmenus) {
        sidebarMenuRef.value.collapseAllSubmenus();
    }
});

// Listen for guide tour sidebar toggle requests
const handleGuideTourToggle = (event) => {
    isCollapsed.value = event.detail.collapsed;
}

onMounted(() => {
    window.addEventListener('guide-tour:toggle-sidebar', handleGuideTourToggle)
})

onUnmounted(() => {
    window.removeEventListener('guide-tour:toggle-sidebar', handleGuideTourToggle)
})

</script>

<template>
    <div class="sidebar-container" :class="{ collapsed: isCollapsed }" id="sidebarContainer">
        <div class="sidebar-header">
            <Link :href="route('dashboard.index')" class="logo" id="logo">
                <img src="../../../assets/img/logo.png" alt="Logo" />
            </Link>
        </div>

        <SidebarMenu ref="sidebarMenuRef" :collapsed="isCollapsed" />

        <div class="d-block text-right">
            <button class="toggle-sidebar" id="toggleSidebar" @click="toggleSidebar" title="Menu inklappen">
                <ArrowLeftFromLine :size="24" :stroke-width="2.5" />
            </button>
        </div>
    </div>
</template>

<style scoped>
/* Using consolidated layout styles from our new CSS architecture */
/* Component-specific overrides only */
</style>
